import React from "react";
import "./About.css"; // Import the CSS file
import { FaPhoneAlt } from "react-icons/fa";
const About = () => {
  return (
    <>
      <div className="full-about">
        <section className="about">
          <div className="left">
            <p className="intro">About Mining</p>
            <h1>Extracting minerals with cutting-edge methods</h1>
            <p className="description">
              The industry of setting up mineral processing plants and bulk
              material handling systems since 1975. Focused on the innovation,
              design, and production of industrial stone crushing & screening
              machinery. Equipped with advanced technology and a skilled team of
              R&D, production professionals!
            </p>
          </div>
          <div className="right">
            <p className="highlight">
              We have created a complete production system, with core products
              including stone crushing and screening machinery services!
            </p>
            <img src="about.webp" alt="Mining Operations" />
          </div>
        </section>

        <section className="call">
          <div className="call-content">
            <h1>New to mining service?</h1>
            <FaPhoneAlt className="phone-icon" />
            <div className="call-info">
              <p className="call-text">
                Contact Us At{" "}
                <span className="phone-number">+91 0000-123-45</span>
              </p>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default About;
